﻿import {KeysetQuery, KeysetQueryResult, translation} from "@2d-front-monorepo/core";
import {
	KeysetPager,
	Table,
	TableColumn,
	TableColumnType
} from "@2d-front-monorepo/design-library";
import {
	BillingDataSingle,
	formatCurrency,
	formatDateTimeShort,
	PaymentHistoryEntry,
	Tariffs,
	Vehicles
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {API_ENDPOINT} from "../../api-endpoint";
import MaterialIcon from "../../components/MaterialIcon";
import {getGlobalContext} from "../../hooks/getGlobalContext";
import {usePermits} from "../../hooks/usePermits";
import {formatRoute} from "../../routes";

interface PermitInvoicesProps {
	data: KeysetQueryResult<PaymentHistoryEntry>;
	loading: boolean;
	onPageChange: (query: KeysetQuery<number>) => void;
}

export default function PermitInvoices({data, loading, onPageChange}: PermitInvoicesProps): JSX.Element {
	const permits = usePermits();
	const {installation} = getGlobalContext();

	return (
		<div className={loading ? "layout--loading" : undefined}>
			<Table data={data.data} className="table--card">
				<TableColumn<PaymentHistoryEntry, "tariffId">
					title={translation(PermitTranslations.permit_type)}
					property="tariffId"
					surrogate={tariffId => Tariffs.get(installation, tariffId).title}/>

				<TableColumn<PaymentHistoryEntry, "operation.id">
					title={translation(PermitTranslations.invoice_id)}
					type={TableColumnType.Number}
					property="operation.id"/>

				<TableColumn<PaymentHistoryEntry, "startDate">
					title={translation(PermitTranslations.date)}
					type={TableColumnType.Date}
					property="startDate"
					surrogate={formatDateTimeShort}/>

				<TableColumn<PaymentHistoryEntry, "operation.step.total">
					title={translation(PermitTranslations.price)}
					type={TableColumnType.Number}
					property="operation.step.total"
					render={value => formatCurrency(value.operation?.step?.total ?? (value.billingData as BillingDataSingle)?.step?.total)}/>

				<TableColumn<PaymentHistoryEntry, "vehicleIds">
					title={translation(PermitTranslations.vehicles)}
					type={TableColumnType.Text}
					property="vehicleIds"
					surrogate={vehicleIds => {
						return Vehicles.getAll(permits, vehicleIds!).map(((vehicle, index) => (
								<div key={index}>[{vehicle.plate}] {vehicle.data?.nickname}</div>)
						));
					}}/>

				<TableColumn<PaymentHistoryEntry, "permitId">
					title={""}
					type={TableColumnType.Actions}
					property="permitId"
					render={value => {
						if (value.operation == null) {
							return null;
						}
						return (<>
							<a href={`${formatRoute(API_ENDPOINT.permitInvoice, value.permitId, value.operation.id, installation.id)}`}
							   target="_blank"
							   download
							   title={translation(PermitTranslations.download)}>
								<MaterialIcon icon="download"/>
							</a>
						</>);
					}}/>
			</Table>

			<KeysetPager keyField={"id"} items={data} onPageChange={onPageChange}/>
		</div>
	);
}
